@let buildData = componentBuildData();

<div class="catalog-item">
  <div #preview class="preview h-100">
    @if (buildData !== null) {
      <ng-container *ngComponentOutlet="buildData.component; injector: buildData.injector"></ng-container>
    }
  </div>
</div>
